import { Col } from "antd";
import React, { Fragment, useEffect } from "react";
import { Info } from "../../../../assets/svg";
import { DateField, InputField, ReactSelectField } from "../../../atoms/FormElement";
import { getInputPlaceholderMessage, getSelectPlaceholderMessage } from "../../../libs/form";
import { filterDropdownValue, filterKycSelectList, kycInitValue, KYC_CONTENT } from "./utils";
interface IProps {}

/**
 * @author
 * @function @
 **/

const kycDetails = (props) => {
  const { kycDetail, control, errors, userKycInfo, setValue, colSpan } = props;

  useEffect(() => {
    if (kycDetail?.length > 0 && userKycInfo) {
      kycDetail.forEach((element) => {
        if (element?.type === "select") {
          filterDropdownValue(kycInitValue(element.name, userKycInfo), filterKycSelectList(element.options[0]));
        } else {
          setValue(`kyc-${element.name}`, kycInitValue(element.name, userKycInfo));
        }
      });
    }
  }, [JSON.stringify(userKycInfo)]);

  return (
    <>
      {kycDetail.map((item: any, index: number) => {
        const tooltip = {
          title: KYC_CONTENT,
          icon: <Info width="16px" height="16px" />,
        };

        return (
          <Fragment key={item?.name + index}>
            {["text", "number", "numberWithComma"].includes(item.type) && (
              <Col span={colSpan}>
                <InputField
                  // isRequired={item?.rules?.required ? true : false}
                  control={control}
                  label={item.label}
                  fieldname={`kyc-${item.name}`}
                  // validate={errors[`kyc-${item.name}`] && "error"}
                  setValue={setValue}
                  // validMessage={errors[`kyc-${item.name}`] && errors[`kyc-${item.name}`].message}
                  iProps={{ placeholder: getInputPlaceholderMessage(item.label) }}
                  initValue={kycInitValue(item.name, userKycInfo)}
                  valueGot={kycInitValue(item.name, userKycInfo)}
                  {...{ tooltip }}
                  // rules={item?.rules?.required ? { required: `${item.label} is required` } : item?.rules}
                />
              </Col>
            )}

            {["date"].includes(item.type) && (
              <Col span={colSpan}>
                <DateField
                  control={control}
                  label={item.label}
                  // isRequired={item?.rules?.required ? true : false}
                  setValue={setValue}
                  fieldname={`kyc-${item.name}`}
                  iProps={{
                    placeholder: "DD-MM-YYYY",
                  }}
                  valueGot={userKycInfo ? kycInitValue(item.name, userKycInfo) : ""}
                  initValue={kycInitValue(item.name, userKycInfo)}
                  {...{ tooltip }}
                  // validate={errors[`kyc-${item.name}`] && "error"}
                  // validMessage={errors[`kyc-${item.name}`] && errors[`kyc-${item.name}`].message}
                />
              </Col>
            )}

            {["select"].includes(item.type) && (
              <Col span={colSpan}>
                <ReactSelectField
                  control={control}
                  label={item.label}
                  fieldname={`kyc-${item.name}`}
                  // isRequired={item?.rules?.required ? true : false}
                  setValue={setValue}
                  iProps={{ placeholder: getSelectPlaceholderMessage(item.label) }}
                  selectOption={filterKycSelectList(item.options[0])}
                  // validate={errors[`kyc-${item.name}`] && "error"}
                  // rules={item?.rules?.required ? { required: `${item.label} is required` } : item?.rules}
                  // validMessage={
                  //   errors[`kyc-${item.name}`] && errors[`kyc-${item.name}`].message
                  // }
                  valueGot={
                    userKycInfo
                      ? filterDropdownValue(kycInitValue(item.name, userKycInfo), filterKycSelectList(item.options[0]))
                      : { value: "", label: "" }
                  }
                  initValue={filterDropdownValue(
                    kycInitValue(item.name, userKycInfo),
                    filterKycSelectList(item.options[0])
                  )}
                  {...{ tooltip }}
                />
              </Col>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default React.memo(kycDetails);
